import React from "react";
import { FormattedMessage } from "react-intl";
import "./footer.css";

const Footer = () => {
  return (
    <footer id="footer" className="footer-wrapper">
      <div className="container footer-content">
        <FormattedMessage id="footer.text" defaultMessage="Developed by Ny NIVOARIJAONA." />
      </div>
    </footer>
  );
};

export default Footer;
